import { Component, Input, SimpleChanges } from '@angular/core';
import { BatteryTypeOption, toBatteryTypeSeries } from 'src/app/_shared/utils/battery-type';
import { TransformXAxisPipe } from 'src/app/_shared/pipes/transform-xaxis.pipe';
import { createPlotlyChart } from 'src/app/_shared/plotlyConfig';

@Component({
  selector: 'app-soc-events-high',
  templateUrl: './soc-events-high.component.html',
  styleUrls: ['./soc-events-high.component.scss']
})
export class SocEventsHighComponent {
  @Input() fleetId: string[] = [];
  @Input() selectedBatteryTypes: BatteryTypeOption[] = [];
  @Input() dataLoadingSocEvents!: boolean;
  @Input() errorMessageSocEvents!: boolean;
  @Input() stateOfChargeEventsDatapoints!: any;
  chartRange!: { range: [number, number]; };
  
  ngOnChanges(changes: SimpleChanges): void {
    if (Object.keys(this.stateOfChargeEventsDatapoints).length !== 0) {
      this.plotSocEventsHigh();
    }
  }
  plotSocEventsHigh() {
    const transformXAxisPipe = new TransformXAxisPipe();

    const data = toBatteryTypeSeries(this.stateOfChargeEventsDatapoints, this.selectedBatteryTypes).map((series) => {
      const filteredData = series.datapoints.filter((dataObject: any) => dataObject.highSocEvents !== null);
      return {
        x: filteredData.map((dataObject: any) => dataObject.binSocEvents),
        y: filteredData.map((dataObject: any) => dataObject.highSocEvents),
        type: 'bar',
        name: series.label,
        marker: {
          color: series.color
        }
      };
    });

    const highSoc = data.flatMap((trace) => trace.x);
    const percentAmount = data.flatMap((trace) => trace.y);

    if (percentAmount.length === 0) {
      this.errorMessageSocEvents = true;
      return;
    } else {
      this.errorMessageSocEvents = false;
    }

    this.chartRange = transformXAxisPipe.transform(highSoc, percentAmount, 5, 100);

    const layout = {
      title: 'High State of Charge Events',
      font: {
        family: 'boschsans, Helvetica Neue, Helvetica, Arial, sans-serif',
        size: 13,
      },
      barmode: 'group',
      xaxis: {
        title: 'Number of high State of Charge events',
        range: this.chartRange?.range
      },
      yaxis: {
        title: 'Percentage of Fleet Vehicles [%]'
      },
      showlegend: true,
      legend: {
        orientation: 'h',
        y: -0.3,
        xanchor: 'center',
        x: 0.5,
        font: {
          family: 'boschsans, Helvetica Neue, Helvetica, Arial, sans-serif',
          size: 13,
        },
      }
    };
    createPlotlyChart('soc-events-high', data, layout);
  }
  
}
